import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { graphql, useStaticQuery } from "gatsby";
import { imageUrlFor } from "../lib/image-url";
import { buildImageObj } from "../lib/helpers";

function Seo({ description, lang, meta, title, image, author, autoSiteTitle,cannonical = '' }) {
  const { site } = useStaticQuery(detailsQuery) || {};
  
  const metaDescription = description || site.seo?.description || "";
  const siteTitle = site.seo?.title || site.title || "";
  const metaImage = image?.asset ? (
      imageUrlFor(buildImageObj(image)).width(1200).url()
    ) : (
      site.seo.thumbnail?.asset ? (
        imageUrlFor(buildImageObj(site.seo.thumbnail)).width(1200).url()
      ) : (
        ""
      )
    );
  const metaImageAlt = image?.asset ? (
      image.alt
    ) : (
      site.seo.thumbnail?.asset ? (
        site.seo.thumbnail.alt
      ) : (
        ""
      )
    );
  const metaAuthor = author?.name
    ? author.name
    : "";

  return (
    <Helmet
      htmlAttributes={{ lang }}
      title={title}
      titleTemplate={(autoSiteTitle && title !== siteTitle) ? `%s | ${siteTitle}` : "%s"}
      meta={[
        {
          name: "description",
          content: metaDescription,
        },
        {
          property: "og:title",
          content: title,
        },
        {
          property: "og:description",
          content: metaDescription,
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:image",
          content: metaImage,
        },
        {
          property: "og:image:alt",
          content: metaImageAlt,
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:creator",
          content: metaAuthor,
        },
        {
          name: "twitter:title",
          content: title,
        },
        {
          name: "twitter:description",
          content: metaDescription,
        },
        {
          property: "twitter:image",
          content: metaImage,
        },
        {
          property: "twitter:image:alt",
          content: metaImageAlt,
        },
      ]
        .concat(meta)}
      link={cannonical ? [{ rel: "canonical", href: cannonical }] : []}
    />
  );
}

Seo.defaultProps = {
  lang: "en",
  meta: [],
};

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  title: PropTypes.string.isRequired,
  image: PropTypes.object,
  author: PropTypes.string,
};

export default Seo;

const detailsQuery = graphql`
  query DefaultSeoQuery {
    site: sanitySiteSettings(_id: { eq: "siteSettings" }) {
      title
      seo {
        title
        description
        thumbnail {
          asset {
            _id
          }
          alt
        }
      }
    }
  }
`;
